import SwitchFormContratanteAsegurado from 'components/Polizas/SwitchFormContratanteAsegurado';
import useQueryParams from 'hooks/useQueryParams';
import _ from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import useAsegurados from 'redux/hooks/emision/useAsegurados';
import useCatalogos from 'redux/hooks/emision/useEmision';

const Seccion = (props) => {
  const { codProducto } = useQueryParams();
  const { catalogoForm } = useAsegurados();
  const {
    municipios,
    colonias,
    findMunicipios,
    findColonias,
    setMunicipios,
    setColonias,
    loadingMunicipios,
    loadingColonias,
  } = useCatalogos();

  const methods = useFormContext();

  const onCheckSeccion = (evt) => {
    try {
      const isChecked = evt?.target?.checked;

      props.copyFields.forEach((field) => {
        try {
          let value = _.get(catalogoForm?.sources, field?.path, field?.default);
          if (isChecked && props?.codigo === 'ubicacion') {
            switch (field?.name) {
              case 'estado':
                onChangeEstado(value);
                break;

              case 'municipio':
                onChangeMunicipio(value);
                break;

              case 'colonia':
                onChangeColonia(value);

                break;

              default:
                break;
            }
          }
          methods.setValue(field?.name, isChecked ? value : field?.defaultOnUCheck);
          methods.trigger(field?.name).then(console.log);
        } catch (error) {}
      });
    } catch (error) {}
  };

  const onChangeEstado = async (estado) => {
    methods.setValue('municipio', null);
    methods.setValue('colonia', null);
    methods.setValue('codigoPostal', '');
    setMunicipios([]);
    setColonias([]);
    if (estado) {
      await findMunicipios(estado.codPais, estado.codDpto);
    }
  };

  const onChangeMunicipio = async (municipio) => {
    methods.setValue('colonia', null);
    methods.setValue('codigoPostal', '');
    setColonias([]);
    if (municipio) {
      await findColonias(municipio);
    }
  };

  const onChangeColonia = (colonia) => {
    methods.setValue('codigoPostal', colonia?.codPostal);
    methods.clearErrors('codigoPostal');
  };

  return (
    <div className="row w-100 justify-content-center my-3">
      <div className="col-12 ml-5">
        <div className="d-flex flex-row flex-wrap">
          <div className="align-self-center" style={{ width: '50px' }}>
            <img className="img-fluid" src={props.urlIcono} alt={props.label} />
          </div>
          <h2 className="text-primary align-self-center">{props.label}</h2>
          {props?.checkboxActivo && (
            <div className="align-self-center ml-1 mt-1">
              <input
                type="checkbox"
                id={props?.label}
                className="chek-terminos ml-2"
                onChange={onCheckSeccion}
              />
              <label htmlFor={props?.label} className="term-condiciones">
                Usar información del contratante
              </label>
            </div>
          )}
        </div>
      </div>

      <div className="col-12">
        <div className="row justify-content-center">
          <div className="col-md-11 col-lg-10">
            <div className="row justify-content-center justify-content-lg-between">
              <SwitchFormContratanteAsegurado
                formulario="asegurados"
                producto={codProducto}
                campos={props.campos}
                catalogo={catalogoForm}
                onChanges={{ onChangeEstado, onChangeMunicipio, onChangeColonia }}
                loadings={{ loadingMunicipios, loadingColonias }}
                sources={{ municipios, colonias }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seccion;
